describe('@/store/modules/Auth', () => {
  it('exports a valid Vuex module', () => {
    expect(name).toBeAVuexModule()
  })
})
